import { CSSProperties } from 'react';

export const tileLayoutStyle: CSSProperties = {
    padding: 0,
    // minHeight: '500px',
};
